import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {
  AerosolArea,
  CheckNotes,
  InspectionAerosolShutdown
} from '@authority-labs/api-interfaces';

@Component({
  selector: 'authority-labs-aerosol-shutdown-test-results',
  templateUrl: './aerosol-shutdown-test-results.component.html',
  styleUrls: ['./aerosol-shutdown-test-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class AerosolShutdownTestResultsComponent implements OnInit {
  @Input() inspection: InspectionAerosolShutdown;

  mainItems: { label: string; value: string; notes: CheckNotes[] }[] = [];
  areasNotes: { title: string; notes: string[] }[] = [];

  ngOnInit(): void {
    this.mainItems = [
      {
        label: this.inspection.aerosolShutdownDesign.main.hubLocation.title,
        value: this.inspection.aerosolShutdownDesign.main.hubLocation.value,
        notes: this.inspection.aerosolShutdownDesign.main.hubLocation.getNotes()
      },
      {
        label: this.inspection.aerosolShutdownDesign.main.hubMadeFrom.title,
        value: this.inspection.aerosolShutdownDesign.main.hubMadeFrom.value,
        notes: this.inspection.aerosolShutdownDesign.main.hubMadeFrom.getNotes()
      },
      {
        label: this.inspection.aerosolShutdownDesign.main.hubModel.title,
        value: this.inspection.aerosolShutdownDesign.main.hubModel.value,
        notes: this.inspection.aerosolShutdownDesign.main.hubModel.getNotes()
      },
      {
        label: this.inspection.aerosolShutdownDesign.main
          .detectionSystemTestedBy.title,
        value: this.inspection.aerosolShutdownDesign.main
          .detectionSystemTestedBy.value,
        notes: this.inspection.aerosolShutdownDesign.main.detectionSystemTestedBy.getNotes()
      },
      {
        label: this.inspection.aerosolShutdownDesign.main.protectedAreas.title,
        value: this.inspection.aerosolShutdownDesign.main.protectedAreas.value,
        notes: this.inspection.aerosolShutdownDesign.main.protectedAreas.getNotes()
      },
      {
        label: this.inspection.aerosolShutdownDesign.main.siteRiskLevel.title,
        value: this.inspection.aerosolShutdownDesign.main.siteRiskLevel.value,
        notes: this.inspection.aerosolShutdownDesign.main.siteRiskLevel.getNotes()
      }
    ];

    this.areasNotes = this.inspection.aerosolShutdownDesign.areas
      .map((area) => {
        const title =
          area?.aerosol?.boardDetailsOrProtectedSpace?.value || '--';
        const notes = new AerosolArea(area)
          .getNotes()
          .filter((note) => note.addNotesToReport && note.notes)
          .filter((note) => !note.notes.includes('undefined'))
          .map((note) => note.notes);

        return { title, notes };
      })
      .filter((area) => area.notes.length > 0);
  }
}
